import React from 'react';
import StarRating from './StarRating';

const SimpleRating = ({studentCount}) => {
  const formattedCount = Math.round(studentCount / 100) * 100;

  return (
    <div className="flex items-center space-x-4">
      <div className="flex items-center space-x-1">
        <StarRating initialRating={4.8} displayOnly />
        <span className="text-gray-700 font-bold text-sm ml-2">4.8/5</span>
        <span className="text-gray-400">•</span>
        <span className="text-gray-800 font-bold text-sm">
          Trusted by
          {' '}
          {formattedCount.toLocaleString()}
          + students
        </span>
      </div>
    </div>
  );
};

export default SimpleRating;
